<form [formGroup]="emailForm">
  @if (modalActive) {
    <div class="email-modal-scrim"></div>
  }
  @if (showEmailCapture) {
    <div class="w-full fixed bottom-0 z-50 transition-all pointer-events-none"
      [ngClass]="useInversePanel ? 'text-black' : 'text-vis-reverse'"
      [class]="isMinimized ? 'transform translate-y-[76%]  sm:translate-y-[72%]' : ''"
      [class.email-modal]="modalActive"
      [class.email-modal-from-tab]="modalActive && modalForceOpen"
      [class.email-no-transition]="suppressTransition"
      >
      <div class="mx-auto w-full sm:max-w-[890px] flex flex-col p-v-spacing pt-0 px-0 relative pb-8 banner pointer-events-auto"
        [ngClass]="useInversePanel ? 'slideup-inverse' : 'bg-ace-pink-600 rounded-t-md'"
        [attr.role]="modalActive ? 'dialog' : null"
        [attr.aria-label]="modalActive ? 'Email discount offer' : null"
        [class.minimized]="isMinimized">
        @if (displayConfetti) {
          <canvas id="canvas" class="pointer-events-none" style="position: absolute; width: 575px; height: 306px; left: 0px; bottom: 0px;"></canvas>
        }
        <button
          type="button"
          class="absolute right-6 cursor-pointer transition-all delay-100"
          [class]="!isMinimized ? 'rotate-180 top-6' : 'rotate-0  top-3'"
          [attr.aria-label]="isSubmited ? 'Close the discount confirmation' : 'Minimize the offer'"
          (click)="isSubmited ? close() : toggleSize()">
          @if (!isSubmited) {
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.12998 15.2901L12.01 11.4101L15.89 15.2901C16.28 15.6801 16.91 15.6801 17.3 15.2901C17.69 14.9001 17.69 14.2701 17.3 13.8801L12.71 9.29006C12.32 8.90006 11.69 8.90006 11.3 9.29006L6.70998 13.8801C6.31998 14.2701 6.31998 14.9001 6.70998 15.2901C7.09998 15.6701 7.73998 15.6801 8.12998 15.2901Z" [attr.fill]="useInversePanel ? '#000000' : '#FFFFFF'"/>
            </svg>
          }
          @if (isSubmited) {
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.37142 18.7071C6.98251 19.096 6.34612 19.096 5.95721 18.7071C5.5683 18.3182 5.5683 17.6818 5.95721 17.2929L17.2709 5.97918C17.6598 5.59027 18.2962 5.59027 18.6851 5.97918C19.074 6.36809 19.074 7.00449 18.6851 7.3934L7.37142 18.7071Z" [attr.fill]="useInversePanel ? '#000000' : '#FFFFFF'"/>
              <path d="M17.2709 18.7071C17.6598 19.096 18.2962 19.096 18.6851 18.7071C19.074 18.3182 19.074 17.6818 18.6851 17.2929L7.37142 5.97918C6.98251 5.59027 6.34612 5.59027 5.95721 5.97918C5.5683 6.36809 5.5683 7.00449 5.95721 7.3934L17.2709 18.7071Z" [attr.fill]="useInversePanel ? '#000000' : '#FFFFFF'"/>
            </svg>
          }
        </button>
        <div class="captureBody">
          @if (!isSubmited) {
            <div class="wysiwyg pb-6 mt-0 pr-14 sm:pr-8 pt-8 pl-6 sm:pl-8 email-capture-content cursor-pointer" [innerHtml]="displayContent" (click)="toggleSize()"></div>
          }
          @if (!isSubmited && !displayContent) {
            <div class="pb-6 -mt-8 pr-14 sm:pr-8 pt-0 sm:pt-2 pl-6 sm:pl-8 email-capture-no-content cursor-pointer" (click)="toggleSize()">
              <h4 class="pr-6 sm:pr-0">{{ emailCaptureTitle }}</h4>
              <div class="wysiwyg" [innerHTML]="emailCaptureContent"></div>
            </div>
          }
          @if (isSubmited) {
            <div class="mb-v-spacing mt-0 pr-6 sm:pr-8 pt-8 pl-6 sm:pl-8">
              <div class="wysiwyg" [innerHTML]="emailCaptureContent"></div>
            </div>
          }
          @if (!isSubmited) {
            <div class="sm:flex sm:flex-row pl-6 sm:pl-8 pr-6 sm:pr-8">
              <input
                type="text"
                placeholder="Email Address"
                class="outline-none h-12 rounded-md p-1 pl-3 border border-gray-300 text-base mr-2 text-gray-900 w-full mb-2 sm:mb-0"
                [class.slideup-inverse-input]="useInversePanel"
                formControlName="email"
                required
                trackElement
                elementId="page_emailcapture_email"
                elementType="email_form"
                elementPosition="footer"
                [trackEvents]="['focus']"
                />
              <button
                class="btn-discount w-full sm:h-auto h-12 cursor-pointer inline-flex items-center justify-center rounded-full"
                [ngClass]="useInversePanel
                  ? 'bg-visBtn-primary hover:bg-visBtn-primaryHover text-vis-reverse-button font-bold'
                  : 'bg-ace-blue-600 hover:bg-ace-blue-700 text-vis-reverse'"
                (click)="submit()"
                >
                {{ buttonLabel }}
              </button>
            </div>
          }
          @if (isEmailInvalid) {
            <p class="text-xs pl-6 pr-6">{{ emailError }}</p>
          }
        </div>
      </div>
    </div>
  }
  @if (showStickyTab && !modalActive) {
    <button
      type="button"
      class="sticky-offer-tab"
      [class.sticky-offer-tab--dec]="useDecModalTheme"
      aria-label="Reopen the $5 off offer"
      (click)="reopenFromTab()"
    >
      <span class="sticky-offer-tab__amount">$5</span>
      <span class="sticky-offer-tab__label">OFF</span>
    </button>
  }
</form>

